import keyBy from 'lodash/keyBy';
import { createSelector } from 'reselect';
import { getRoomTypesWithoutOffers as getAllRoomTypes } from 'store/property/propertySelectors';
import { getAvailableRoomTypes } from './getAvailableRoomTypes';

export const getUnavailableRoomTypes = createSelector(getAllRoomTypes, getAvailableRoomTypes, (allRoomTypes, availableRoomTypes) => {
  const availableById = keyBy(availableRoomTypes, (room) => room.id);
  const unavailableRoomTypes = [];

  allRoomTypes.forEach((room) => {
    if (!availableById[room.id]) {
      unavailableRoomTypes.push(room);
    }
  });

  return unavailableRoomTypes;
});
